import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import {withMemo} from 'helpers/wrapper';
import utils from 'helpers/utils';
import StyledNarration from 'components/molecules/Narrations/Narration/Narration.styles';
import Box from 'components/atoms/Layout/Box/Box';
import Icon from 'components/atoms/Icons/Icon/Icon';
import Typography, {H6} from 'components/atoms/Text/Typography/Typography';
import ActionIconButton from 'components/molecules/Buttons/ActionIconButton/ActionIconButton';
import ActionButton from 'components/molecules/Buttons/ActionButton/ActionButton';
import LinearProgress from 'components/atoms/Progress/LinearProgress/LinearProgress';
import Close from '@mui/icons-material/Close';
import RecordVoiceOver from '@mui/icons-material/RecordVoiceOver';

const Narration = withMemo(React.forwardRef((props, ref) => {
  const {
    title,
    icon,
    narration,
    aside,
    error,
    progress,
    actions,
    onClose,
    ...innerProps
  } = useComponentProps({
    elevation: 2,
    radius: 'roundest',
    icon: RecordVoiceOver,
    ...props
  }, 'Narration');

  const closeAction = useMemo(() => ({
    icon: <Icon icon={Close}/>,
    tooltip: 'Close',
    color: 'white',
    onClick: () => onClose?.()
  }), [onClose]);

  return <StyledNarration ref={ref} {...innerProps}>
    <Box className="Narration-header">
      <H6 className="Narration-title">{title}</H6>
      <ActionIconButton action={closeAction}
                        size="smaller"
                        density="dense"
                        variant="transparent"/>
    </Box>
    <Box className="Narration-content">
      <Box className="Narration-speech">
        <Icon className="Narration-icon"
              icon={icon}
              color={error ? 'error' : 'primary'}/>
        <Box className="Narration-texts">
          <Typography className="Narration-narration"
                      variant="body1"
                      {...(error ? {color: 'error'} : null)}>
            {narration}
          </Typography>
          {aside ?
            <Typography className="Narration-aside"
                        variant="caption">
              {aside}
            </Typography> : null}
        </Box>
      </Box>
      {(utils.isDefined(progress) || actions?.length > 0) ?
        <Box className="Narration-footer">
          {utils.isDefined(progress) ?
            <LinearProgress className="Narration-progress"
                            variant="determinate"
                            color="primary"
                            value={progress}/> : null}
          {actions?.length > 0 ?
            <Box className="Narration-actions">
              {actions.map((action, idx) => {
                return <ActionButton key={idx} action={action} size="small"/>
              })}
            </Box> : null}
        </Box> : null}
    </Box>
  </StyledNarration>
}));

Narration.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  title: PropTypes.any,
  icon: PropTypes.any,
  narration: PropTypes.any,
  aside: PropTypes.any,
  error: PropTypes.bool,
  progress: PropTypes.number,
  actions: PropTypes.array,
  onClose: PropTypes.func
};

export default Narration;
